__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "host";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("lodash", "4.17.21", function() { return __webpack_require__.e(668).then(function() { return function() { return __webpack_require__(668); }; }); });
			register("mitt", "3.0.0", function() { return __webpack_require__.e(9391).then(function() { return function() { return __webpack_require__(9391); }; }); });
			register("pinia-plugin-persistedstate", "2.1.1", function() { return __webpack_require__.e(4454).then(function() { return function() { return __webpack_require__(4454); }; }); });
			register("pinia", "2.0.21", function() { return __webpack_require__.e(7476).then(function() { return function() { return __webpack_require__(7476); }; }); });
			register("portal-vue", "3.0.0-beta.0", function() { return __webpack_require__.e(6913).then(function() { return function() { return __webpack_require__(6913); }; }); });
			register("vue-i18n", "9.2.2", function() { return __webpack_require__.e(6097).then(function() { return function() { return __webpack_require__(6097); }; }); });
			register("vue-router", "4.1.5", function() { return __webpack_require__.e(2201).then(function() { return function() { return __webpack_require__(2201); }; }); });
			register("vue", "3.2.38", function() { return __webpack_require__.e(2567).then(function() { return function() { return __webpack_require__(2567); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};